﻿import { SystemBase } from "./system.base";

export class HTMLSystem extends SystemBase {

    constructor(private root: HTMLElement) {
        super();

        // Create a callback function
        const callback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Nodes added
                    mutation.addedNodes.forEach(node => {
                        
                        // Trigger your custom logic here
                    });

                    // Nodes removed
                    mutation.removedNodes.forEach(node => {
                        
                    });
                }

                if (mutation.type === 'attributes') {
                    
                }
            }
        };

        // Create an observer instance
        const observer = new MutationObserver(callback);

        // Configure what to observe
        observer.observe(root, {
            childList: true,     // detect added/removed child nodes
            subtree: true,       // watch all descendants, not just direct children
            attributes: true     // optional: detect attribute changes
        });
    }

    update(time: number, delta: number): void {
        
    }

    endOfFrame(): void {
        
    }

}